<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear
          absolute
          color="success"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="buttons-tab"></div>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-alert
                v-if="isSystemType"
                type="info"
                dense
                outlined
                class="mb-4"
              >
                {{ $t("DEAL_DOCUMENT_TYPES.SYSTEM_EDIT_LIMITED") }}
              </v-alert>
              <v-form ref="dealDocumentTypeForm" v-model="validDealDocumentTypeForm" @submit.prevent>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="requestData.name"
                      :label="`${$t('GENERAL.LABELS.NAME')} *`"
                      :disabled="isSystemType"
                      :rules="isSystemType ? [] : [validations.required()]"
                      :error-messages="validationErrors.name || []"
                      @change="clearValidationError('name')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-checkbox
                      v-model="requestData.required"
                      :label="$t('DEAL_DOCUMENT_TYPES.REQUIRED')"
                      :error-messages="validationErrors.required || []"
                      @change="clearValidationError('required')"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back">
                {{ $t("GENERAL.LABELS.BACK_BUTTON") }}
              </v-btn>
              <v-btn
                v-if="!isSystemType || isEditMode"
                color="success"
                @click="store"
              >
                {{ actionText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import validations from "@/views/partials/form/Validations.vue";
import { SHOW_SNACK } from "@/store/snack.module";
import userStateService from "@/common/userState.service.js";
import {
  GET_DEAL_DOCUMENT_TYPE,
  STORE_DEAL_DOCUMENT_TYPE,
  UPDATE_DEAL_DOCUMENT_TYPE,
} from "@/store/dealDocumentTypes.module";

export default {
  name: "EditDealDocumentType",
  data() {
    return {
      validations,
      tab: "tab-1",
      isProcessing: false,
      validDealDocumentTypeForm: false,
      validationErrors: {},
      isSystemType: false,
      title: "",
      actionText: this.$t("GENERAL.LABELS.CREATE_BUTTON"),
      requestData: {
        name: "",
        required: false,
      },
    };
  },
  computed: {
    isEditMode() {
      return Boolean(this.$route.params.id);
    },
  },
  mounted() {
    this.title = this.$t("DEAL_DOCUMENT_TYPES.CREATE");
    this.loadDealDocumentType();
  },
  methods: {
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];

        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }

      if (error && error.message) {
        return error.message;
      }

      return this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    setValidationErrors(error) {
      this.validationErrors = (error && error.errors) || {};
    },
    clearValidationError(field) {
      if (!this.validationErrors[field]) {
        return;
      }

      this.$delete(this.validationErrors, field);
    },
    loadDealDocumentType() {
      if (!this.$route.params.id) {
        return;
      }

      this.title = this.$t("DEAL_DOCUMENT_TYPES.EDIT");
      this.actionText = this.$t("GENERAL.LABELS.EDIT_BUTTON");
      this.isProcessing = true;

      this.$store
        .dispatch(GET_DEAL_DOCUMENT_TYPE, this.$route.params.id)
        .then((response) => {
          this.requestData = {
            name: response.name || "",
            required: !!response.required,
          };
          this.isSystemType = !!response.is_system;
        })
        .catch((error) => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
          this.back();
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    back() {
      this.$router.push({ name: "deal-document-types" });
    },
    store() {
      if (!this.isSystemType) {
        this.$refs.dealDocumentTypeForm.validate();

        if (!this.validDealDocumentTypeForm) {
          return;
        }
      }

      this.validationErrors = {};

      const action = this.isEditMode
        ? UPDATE_DEAL_DOCUMENT_TYPE
        : STORE_DEAL_DOCUMENT_TYPE;
      const payload = this.isEditMode
        ? {
            id: this.$route.params.id,
            name: this.requestData.name,
            required: this.requestData.required,
          }
        : {
            name: this.requestData.name,
            required: this.requestData.required,
          };

      this.isProcessing = true;

      this.$store
        .dispatch(action, payload)
        .then((response) => {
          const blinkId = response?.id || this.$route.params.id;

          if (blinkId) {
            userStateService.setState(
              "table-state.deal-document-types-table.blinkRowItemKey",
              blinkId
            );
          }

          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.SUCCESS_MESSAGE"),
          });
          this.$router.push({ name: "deal-document-types" });
        })
        .catch((error) => {
          this.setValidationErrors(error);
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
